import * as bootstrap from "bootstrap/dist/js/bootstrap.min.js"
import "@popperjs/core/dist/umd/popper.min.js"
import { exists, window } from "browser-monads"
if (exists(window)) window.Tooltip = bootstrap.Tooltip
